import { LoaderCircle } from 'lucide-react-native';
import { memo, useEffect } from 'react';
import Animated, {
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
} from 'react-native-reanimated';

export type SpinnerProps = {
  size?: number;
  color?: string;
  strokeWidth?: number;
  /** Time for one full rotation in ms. */
  duration?: number;
};

export const Spinner = memo(
  ({
    size = 20,
    color = '#fff',
    strokeWidth = 2.4,
    duration = 900,
  }: SpinnerProps) => {
    const rotation = useSharedValue(0);
    useEffect(() => {
      rotation.value = withRepeat(
        withTiming(360, { duration, easing: Easing.linear }),
        -1,
        false,
      );
    }, [rotation, duration]);
    const style = useAnimatedStyle(() => ({
      transform: [{ rotate: `${rotation.value}deg` }],
    }));
    return (
      <Animated.View style={style}>
        <LoaderCircle size={size} color={color} strokeWidth={strokeWidth} />
      </Animated.View>
    );
  },
);
